<template>
  <div class="maramures">
    <h1>Maramureş, Maramuresch</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
      Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/lemn_1kl.jpg" width="125" border="0" height="110" alt="biserica de lemn, Holzkirche in der Maramuresch" 
        @click="callImageClick('biserica de lemn, Holzkirche in der Maramuresch', 'lemn_1.jpg', $event)">
        <br>biserica de lemn, Holzkirche in der Maramuresch
      </div>
      <div class="foto">
        <img src="../assets/fotos/lemn_2kl.jpg" width="125" border="0" height="110" alt="biserica de lemn, Holzkirche in der Maramuresch" 
        @click="callImageClick('biserica de lemn, Holzkirche in der Maramuresch', 'lemn_2.jpg', $event)">
        <br>biserica de lemn, Holzkirche in der Maramuresch
      </div>
      <div class="foto">
        <img src="../assets/fotos/lemn_3kl.jpg" width="125" border="0" height="110" alt="biserica de lemn, Holzkirche in der Maramuresch" 
        @click="callImageClick('biserica de lemn, Holzkirche in der Maramuresch', 'lemn_3.jpg', $event)">
        <br>biserica de lemn, Holzkirche in der Maramuresch
      </div>
      <div class="foto">
        <img src="../assets/fotos/mara_1kl.jpg" width="125" border="0" height="110" alt="Maramureş, Maramuresch:  - Craciuneşti - Weihnachtsdorf"
        @click="callImageClick('Maramureş, Maramuresch:  - Craciuneşti - Weihnachtsdorf', 'mara_1.jpg', $event)">
        <br>Maramureş, Maramuresch: Craciuneşti - Weihnachtsdorf
			</div>
      <div class="foto">
				<img src="../assets/fotos/mara_2kl.jpg" width="125" height="110" border="0" alt="Maramureş, Maramuresch: links Breitspur, rechts Normalspur"
        @click="callImageClick('Maramureş, Maramuresch: links Breitspur, rechts Normalspur', 'mara_2.jpg', $event)">
        <br>Maramureş, Maramuresch: links Breitspur, rechts Normalspur
      </div>
      <div class="foto">
        <img src="../assets/fotos/rona_1kl.jpg" width="125" border="0" height="110" alt="casa de lemn, Holzhaus in Rona de Sus"
        @click="callImageClick('casa de lemn, Holzhaus in Rona de Sus', 'rona_1.jpg', $event)">
        <br>casa de lemn, Holzhaus in Rona de Sus
      </div>
      <div class="foto">
        <img src="../assets/fotos/rona_2kl.jpg" width="125" border="0" height="110" alt="casa de lemn, Holzhaus in Rona de Sus"
        @click="callImageClick('casa de lemn, Holzhaus in Rona de Sus', 'rona_2.jpg', $event)">
        <br>casa de lemn, Holzhaus in Rona de Sus
      </div>
      <div class="foto">
        <img src="../assets/fotos/rona_3kl.jpg" width="125" border="0" height="110" alt="casa de lemn, Holzhaus in Rona de Sus"
        @click="callImageClick('casa de lemn, Holzhaus in Rona de Sus', 'rona_3.jpg', $event)">
        <br>casa de lemn, Holzhaus in Rona de Sus
      </div>
      <div class="foto">
        <img src="../assets/fotos/rona_4kl.jpg" width="125" border="0" height="110" alt="casa de lemn, Holzhaus in Rona de Sus"
        @click="callImageClick('casa de lemn, Holzhaus in Rona de Sus', 'rona_4.jpg', $event)">
        <br>casa de lemn, Holzhaus in Rona de Sus
      </div>
      <div class="foto">
        <img src="../assets/fotos/rona_5kl.jpg" width="125" border="0" height="110" alt="casa de lemn, Holzhaus in Rona de Sus"
        @click="callImageClick('casa de lemn, Holzhaus in Rona de Sus', 'rona_5.jpg', $event)">
        <br>casa de lemn, Holzhaus in Rona de Sus
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>